// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"66a716a9","453":"dcf5538b","455":"80c1163b","977":"3a1404b2"}[chunkId] + ".chunk.js";
};